export const TEACHER_COURSES_REQUEST = "TEACHER_COURSES_REQUEST";
export const TEACHER_COURSES_SUCCESS = "TEACHER_COURSES_SUCCESS";
export const TEACHER_COURSES_FAIL = "TEACHER_COURSES_FAIL";

export const EDIT_ENROLLMENT_SUCCESS = "EDIT_ENROLLMENT_SUCCESS";
export const ADD_NEW_COURSE = "ADD_NEW_COURSE";
